export enum Currency {
  CZK = 'CZK',
  EUR = 'EUR',
  USD = 'USD',
}

export const CurrencyValues = Object.values(Currency);

export interface MoneyDto {
  amount: number;
  currency: Currency;
}

export interface ConvertedMoneyDto {
  original: MoneyDto;
  converted?: MoneyDto;
}

export interface ExchangeRate {
  fromCurrency: Currency;
  toCurrency: Currency;
  rate: number;
  updatedAt: string;
}

export interface ExchangeRatesDto {
  rates: ExchangeRate[];
  baseCurrency: Currency;
}

export class CurrencyConverter {
  constructor(private rates: ExchangeRate[]) {}

  convert(amount: number, from: Currency, to: Currency): number {
    if (from === to) return amount;
    const rate = this.rates.find(
      (r) => r.fromCurrency === from && r.toCurrency === to,
    );
    if (!rate) {
      throw new Error(`No exchange rate found for ${from} to ${to}`);
    }
    return amount * rate.rate;
  }

  convertMoney(money: MoneyDto, to: Currency): MoneyDto {
    return {
      amount: this.convert(money.amount, money.currency, to),
      currency: to,
    };
  }

  convertWithOriginal(money: MoneyDto, to: Currency): ConvertedMoneyDto {
    if (money.currency === to) {
      return { original: money };
    }
    const converted = this.convertMoney(money, to);
    return { original: money, converted };
  }
}
